import { Value } from 'slate';
import coverLetterInitialState from './coverLetterDefaultValues';

export default ({ universityPlan }) => {
  const coverLetterDefaultValues = coverLetterInitialState({
    universityPlan,
  });
  return {
    templateType: 'COVER LETTER',
    coverLetterType: 'Attractive',
    formatType: 'Cover Letter',
    documentName: 'Beautiful Template',
    editedInputs: coverLetterDefaultValues.editedInputs,
    userPreferences: coverLetterDefaultValues.userPreferences,
    senderName: Value.fromJSON(coverLetterDefaultValues.senderName),
    senderTagline: Value.fromJSON(coverLetterDefaultValues.senderTagline),
    senderPhoneNumber: Value.fromJSON(
      coverLetterDefaultValues.senderPhoneNumber,
    ),
    senderAddress: Value.fromJSON(coverLetterDefaultValues.senderAddress),
    senderEmail: Value.fromJSON(coverLetterDefaultValues.senderEmail),
    personalLinks: Value.fromJSON(coverLetterDefaultValues.personalLinks),
    receiverName: Value.fromJSON(coverLetterDefaultValues.receiverName),
    receiverTagline: Value.fromJSON(coverLetterDefaultValues.receiverTagline),
    receiverOrganization: Value.fromJSON(
      coverLetterDefaultValues.receiverOrganization,
    ),
    receiverAddress: Value.fromJSON(coverLetterDefaultValues.receiverAddress),
    letterDate: Value.fromJSON(coverLetterDefaultValues.letterDate),
    letterBody: Value.fromJSON(coverLetterDefaultValues.letterBody),
    subjectLine: Value.fromJSON(coverLetterDefaultValues.subjectLine),
    openGreeting: Value.fromJSON(coverLetterDefaultValues.openGreeting),
    closeGreeting: Value.fromJSON(coverLetterDefaultValues.closeGreeting),
  };
};
